import { xy, xyz } from '@/Interfaces/common';

export const height = 1830;
export const depth = 500;

export interface iModelMeta {
    [key: string]: {
        width?: number,
        offset?: xyz,
        scale?: xyz,
        nomWidth?: number
    }
}
export const modelMeta: iModelMeta = {
    'ml_01_30_u': {
        nomWidth: 300,
        width: 301.263,
    },
    'ml_01_30_u_door': {
        width: 300,
        offset: [ 0.261915 ,0.054649 ,0.493381 ],
    },
    'ml_01_40_u': {
        nomWidth: 400,
        width: 401.263,
    },
    'ml_01_40_u_door': {
        width: 400,
        offset: [ 0.364217 ,0.053521 ,0.493798 ],
    },
    'ml_22_60': {
        width: 600,
    },
    'ml_02_30': {
        nomWidth: 300,
        width: 301.263,
    },
    'ml_02_30_door': {
        width: 300,
        offset: [ 0.265051 ,0.05252 ,0.494289 ],
    },
    'ml_02_40': {
        nomWidth: 400,
        width: 400.316,
    },
    'ml_02_40_door': {
        width: 400,
        offset: [ 0.361645 ,0.053779 ,0.494111 ],
    },
    'ml_03_30': {
        nomWidth: 300,
        width: 301.371,
    },
    'ml_03_30_door': {
        width: 300,
        offset: [ 0.264155, 0.053974 , 0.493406 ],
    },
    'ml_04_30': {
        nomWidth: 300,
        width: 301.265,
    },
    'ml_04_30_door': {
        width: 300,
        offset: [ 0.263546 ,0.05278 ,0.49157 ],
    },
    'ml_04_40': {
        nomWidth: 400,
        width: 400.87,
    },
    'ml_04_40_door': {
        width: 400,
        offset: [ 0.363694 ,0.053287 ,0.493241 ],
    },
    'ml_11_30': {
        nomWidth: 300,
        width: 301.263,
    },
    'ml_11_30_door': {
        width: 300,
        offset: [ 0.261914 ,0.054649 ,0.493381 ],
    },
    'ml_11_40': {
        nomWidth: 400,
        width: 401.263,
    },
    'ml_11_40_door': {
        width: 400,
        offset: [ 0.364126 ,0.053521 ,0.493406 ],
    },
    'ml_11_50_base': {
        width: 500,
    },
    'ml_11_50_base_door': {
        width: 500,
    },
    'ml_11_50_d': {
        nomWidth: 500,
        width: 501.263,
    },
    'ml_11_50_d_door': {
        width: 500,
        offset: [ 0.463997,0.053445 ,0.493905 ],
    },
    'ml_12_30': {
        nomWidth: 300,
        width: 301.264,
    },
    'ml_12_30_door': {
        width: 300,
        offset: [ 0.265051 ,0.05252 ,0.494289 ],
    },
    'ml_12_40': {
        nomWidth: 400,
        width: 400.316,
    },
    'ml_12_40_door': {
        width: 400,
        offset: [ 0.361645 ,0.053779 ,0.494112 ],
    },
    'ml_13_30': {
        nomWidth: 300,
        width: 301.371,
    },
    'ml_13_30_door': {
        width: 300,
        offset: [ 0.264155 ,0.053974 ,0.493406 ],
    },
    'ml_13_40': {
        nomWidth: 400,
        width: 399.055,
    },
    'ml_13_40_door': {
        width: 400,
        offset: [ 0.361176 ,0.054001 ,0.492923 ],
    },
    'ml_14_30': {
        nomWidth: 300,
        width: 301.265,
    },
    'ml_14_30_door': {
        width: 300,
        offset: [ 0.263546 ,0.05278 ,0.49157 ],
    },
    'ml_14_40': {
        nomWidth: 400,
        width: 400.87,
    },
    'ml_14_40_door': {
        width: 400,
        offset: [ 0.363694 ,0.053287 ,0.493241 ],
    },
    'ml_21_60': {
        width: 600,
    },
    'ml_21_60_door': {
        width: 600,
    },
    'ml_21_80': {
        width: 800,
    },
    'ml_21_80_door': {
        width: 800,
    },
    'polka_300': {
        offset: [ 0.002,-0.002,0 ],
        width: 299.676,
    },
    'polka_400': {
        offset: [ 0.002,-0.002,0 ],
        width: 400.039,
    },
    'polka_500': {
        width: 500.435,
    },
    '300_baza': {
        width: 300,
    },
    '300_dop': {
        width: 300,
    },
    '400_baza': {
        width: 400,
    },
    '400_dop': {
        width: 400,
    },
    '500_base': {
        width: 500,
    },
    'ml_300': {
        width: 300,
    },
    'ml_300_dop': {
        width: 300,
    },
    'ml_400_baza': {
        width: 400,
    },
    'ml_400_dop': {
        width: 400,
    },
    'ml_500_base': {
        width: 500,
    },
    'ls_11_50': {
        nomWidth: 500,
        width: 500.873,
    },
    'ls_11_50_door': {
         width: 500,
         offset: [ 0.461978,0.053531,0.492521 ],
    },
    'ml_1200': {
        width: 1200,
    },
    'ml_1500': {
        width: 1500,
    },
    'Rack.001': {},
    'ml_41_30': {
        // offset: [ 0.002,0.001,0 ],
        // scale:[ 0.99,1,1 ],
        width: 300,
    },
    'ml_41_40': {
        // offset: [ 0.001,0.001,0 ],
        // scale:[ 0.99,1,1 ],
        width: 400,
    },
    'ml_41_50': {
        // scale:[ 0.995,1,1 ],
        // offset: [ 0.0007,0,0 ],
        width: 500,
    },
    'ml_41_60': {
        // scale:[ 0.99,1,1 ],
        // offset: [ 0.002,0.001,0 ],
        width: 600,
    },
    'ml_41_80': {
        // scale:[ 0.99,1,1 ],
        // offset: [ 0.0025,0.001,0 ],
        width: 800,
    },
    'ml_41_90': {
        // scale:[ 0.994,1,1 ],
        // offset: [ 0.0015,0.001,0 ],
        width: 900,
    },
    'ml_41_100': {
        // offset: [ -0.0005,0,0 ],
        // scale:[ 0.995,1,1 ],
        width: 1000,
    },
    'ml_41_120': {
        // offset: [ 0.0006,0.001,0 ],
        // scale:[ 0.996,1,1 ],
        width: 1200,
    },
    'ml_41_160': {
        // offset: [ 0,0.001,0 ],
        width: 1600,
    },
    'bench300': {
        width: 300,
        // scale:[ 0.967,1,1 ],
        // offset: [ 0.005,0,0 ],
    },
    'bench400': {
        width: 400,
        // scale:[ 0.97,1,1 ],
        // offset: [ 0.003,0,0 ],
    },
    'bench500': {
        width: 500,
        // scale:[ 0.99,1,1 ],
        // offset: [ 0.005,0,0 ],
    },
    'bench900': {
        width: 900,
        // scale:[ 0.995,1,1 ],
        // offset: [ 0.005,0,0 ],
    },
    'bench1200': {
        width: 1200,
        // scale:[ 0.998,1,1 ],
        // offset: [ -0.001,0,0 ],
    },
    'bench1600': {
        width: 1600,
        // offset: [ 0.005,0,0 ],
        // scale:[ 0.999,1,1 ],
    },
    'ml_03_40': {
        // offset: [ 0.0001,0.0,0.0007 ],
        // scale:[ 1.325,1,1 ],
        width: 398.645,
        nomWidth: 400,
    },
    'ml_03_40_door': {
        width: 400,
        offset: [ 0.360805 ,0.054001,0.492923 ],
    },
};
export const modelNames = Object.keys(modelMeta);

export type modelNamesT = keyof typeof modelMeta | '';
